import { z } from "zod";
import { instantSchema } from "@amber/contracts";
import { profileListRowSchema } from "@amber/profiles/contracts";

const countLinkSchema = z.strictObject({ count: z.number().int().nonnegative(), href: z.string() });

export const rosterRowSchema = profileListRowSchema.extend({
  sources: z.number().int().nonnegative(),
  sources_href: z.string(),
  worst_health: z
    .strictObject({ state: z.string(), label: z.string(), count: z.number().int().nonnegative() })
    .nullable(),
  source_problems: z.number().int().nonnegative(),
  platforms: z.array(z.strictObject({ key: z.string(), label: z.string() })),
  appearances: z.number().int().nonnegative(),
  activity: z.strictObject({
    daily: z.array(z.number().int().nonnegative()),
    items_7d: z.number().int().nonnegative(),
    items_30d: z.number().int().nonnegative(),
  }),
  collected: countLinkSchema,
  eligible: countLinkSchema,
  open_gaps: countLinkSchema,
  download_problems: countLinkSchema,
  last_new_item: instantSchema.nullable(),
});
export type RosterRow = z.infer<typeof rosterRowSchema>;

export const rosterResponseSchema = z.strictObject({
  people: z.array(rosterRowSchema),
  summary: z.strictObject({
    open_gaps: z.number().int().nonnegative(),
    plan_reviews_due: z.number().int().nonnegative(),
  }),
});
export type RosterResponse = z.infer<typeof rosterResponseSchema>;
